import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleShoes from "../pages/articles/best-shoes-allchinabuy-spreadsheet-2026/page";
import ArticleHoodies from "../pages/articles/top-hoodies-sweaters-allchinabuy-spreadsheet/page";
import ArticleBeginner from "../pages/articles/allchinabuy-spreadsheet-beginners-guide/page";
import ArticleSellers from "../pages/articles/find-trusted-sellers-allchinabuy-spreadsheet/page";
import ArticlePrice from "../pages/articles/price-comparison-allchinabuy-spreadsheet/page";
import ArticleSafety from "../pages/articles/safe-shopping-allchinabuy-spreadsheet/page";
import ArticleBudget from "../pages/articles/budget-finds-allchinabuy-spreadsheet/page";
import ArticleQuality from "../pages/articles/quality-verification-allchinabuy-spreadsheet/page";
import ArticleAccessories from "../pages/articles/accessories-guide-allchinabuy-spreadsheet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/best-allchinabuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/best-shoes-allchinabuy-spreadsheet-2026",
    element: <ArticleShoes />,
  },
  {
    path: "/top-hoodies-sweaters-allchinabuy-spreadsheet",
    element: <ArticleHoodies />,
  },
  {
    path: "/allchinabuy-spreadsheet-beginners-guide",
    element: <ArticleBeginner />,
  },
  {
    path: "/find-trusted-sellers-allchinabuy-spreadsheet",
    element: <ArticleSellers />,
  },
  {
    path: "/price-comparison-allchinabuy-spreadsheet",
    element: <ArticlePrice />,
  },
  {
    path: "/safe-shopping-allchinabuy-spreadsheet",
    element: <ArticleSafety />,
  },
  {
    path: "/budget-finds-allchinabuy-spreadsheet",
    element: <ArticleBudget />,
  },
  {
    path: "/quality-verification-allchinabuy-spreadsheet",
    element: <ArticleQuality />,
  },
  {
    path: "/accessories-guide-allchinabuy-spreadsheet",
    element: <ArticleAccessories />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;